<template>
    <div class="row" v-if="isValid('CanAddSaleOrder') || isValid('CanDraftSaleOrder') || isValid('CanEditSaleOrder') || isValid('CanDuplicateSaleOrder')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
        <div class="col-md-12 ml-auto mr-auto">
            <div class="card">
                <div class="card-header">
                    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 poHeading" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            <span v-if="purchase.id === '00000000-0000-0000-0000-000000000000'">{{ $t('AddSaleOrder.AddSaleOrder') }} <span style="font-weight:bold">  - {{purchase.registrationNo}}</span></span>
                            <span v-else>{{ $t('AddSaleOrder.UpdateSaleOrder') }} <span style="font-weight:bold">  - {{purchase.registrationNo}}</span></span>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 dateHeading" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <span>
                                {{purchase.date}}
                            </span>
                        </div>
                    </div>
                    <div class="row bottomBorder">

                    </div>
                </div>
                <div class="card-body">
                    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <label>{{ $t('AddSaleOrder.PaymentMethodForSo') }} :<span class="LabelColour"> *</span></label>
                            <div v-bind:class="{'has-danger' : $v.purchase.paymentMethod.$error}">
                                <multiselect v-if="($i18n.locale == 'en' ||isLeftToRight())" v-model="$v.purchase.paymentMethod.$model" v-on:input="RanderCustomer" :options="['Cash', 'Credit']" :show-labels="false" v-bind:placeholder="$t('AddSaleOrder.SelectOption')">
                                </multiselect>
                                <multiselect v-else v-model="$v.purchase.paymentMethod.$model" v-on:input="RanderCustomer" :options="['آجـل', 'الـنـقـدي']" :show-labels="false" v-bind:placeholder="$t('AddSaleOrder.SelectOption')">
                                </multiselect>
                                <span v-if="$v.purchase.paymentMethod.$error" class="error text-danger">
                                    <span v-if="!$v.purchase.paymentMethod.required">{{ $t('AddSaleOrder.PaymentMethodRequired') }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:key="randerCustomer">
                            <label>{{ $t('AddSaleOrder.Customer') }} :<span class="LabelColour"> *</span></label>
                            <div v-bind:class="{'has-danger': $v.purchase.customerId.$error,}">
                                <customerdropdown v-model="$v.purchase.customerId.$model" :paymentTerm="purchase.paymentMethod" v-on:input="getAddress" ref="CustomerDropdown" v-bind:values="purchase.customerId" :key="customerRender" />
                                <span v-if="$v.purchase.customerId.$error"
                                      class="error text-danger">
                                </span>
                            </div>
                        </div>



                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <label>{{ $t('AddSaleOrder.Mobile') }}  :</label>
                            <input type="text" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'"
                                   v-model="purchase.mobile" />
                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                            <label>{{ $t('AddSaleOrder.Refrence') }} :</label>
                            <div v-bind:class="{'has-danger': $v.purchase.refrence.$error,}">
                                <input class="form-control" style="height:42px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'"
                                       v-model="$v.purchase.refrence.$model" />
                                <span v-if="$v.purchase.refrence.$error"
                                      class="error text-danger">
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                            <label>{{ $t('AddSaleOrder.ClientPurchaseNo') }} :</label>
                            <input class="form-control" style="height:42px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'"
                                   v-model="purchase.clientPurchaseNo" />
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                            <label style="width:100%;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">{{ $t('AddSaleOrder.WareHouse') }} :<span class="LabelColour"> *</span></label>
                            <warehouse-dropdown :disable="true" v-model="$v.purchase.wareHouseId.$model" />
                            <span v-if="$v.purchase.wareHouseId.$error"
                                  class="error text-danger">
                            </span>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3" v-if="saleOrder && (isValid('CanDraftQuotation') || isValid('CanViewQuotation'))">
                            <label>{{ $t('AddSaleOrder.Quotation') }} :</label>
                            <quotationdropdown v-model="purchase.quotationId" v-on:input="GetQuotationDetail(purchase.quotationId)" v-bind:values="purchase.quotationId" />
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3 col-3">
                            <label>  {{ $t('AddSaleOrder.Transporter/Cargo') }}  :</label>
                            <logisticDropdown v-model="purchase.logisticId" :values="purchase.logisticId" />
                        </div>

                        <div class="col-lg-3 col-md-3 col-sm-3 col-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            <label>{{ $t('CustomerAddress') }}  :</label>
                            <input v-model="purchase.customerAddress" class="form-control" />
                        </div>




                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="(purchase.paymentMethod=='Cash' || purchase.paymentMethod=='السيولة النقدية') && isRaw=='true' ">
                            <label>{{ $t('AddSaleOrder.SheduleDelivery') }} :</label>
                            <multiselect v-if="($i18n.locale == 'en' ||isLeftToRight())" v-model="purchase.sheduleDelivery" :options="['Advance', 'After Delivery']" :show-labels="false" v-bind:placeholder="$t('SelectOption')">
                            </multiselect>
                            <multiselect v-else v-model="purchase.sheduleDelivery" :options="['تقدم', 'بعد الولادة']" :show-labels="false" v-bind:placeholder="$t('SelectOption')">
                            </multiselect>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="(purchase.sheduleDelivery=='After Delivery' || purchase.sheduleDelivery=='بعد الولادة') && (purchase.paymentMethod=='Cash' || purchase.paymentMethod=='السيولة النقدية') && isRaw=='true' ">
                            <label>{{ $t('AddSaleOrder.Days') }} :</label>
                            <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'"
                                   v-model="purchase.days" />
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="(purchase.paymentMethod=='Cash' || purchase.paymentMethod=='السيولة النقدية') && isRaw=='true' ">
                            <label class="row pl-3 mt-2 ">{{ $t('AddSaleOrder.DeliveryTerms') }}  :</label>
                            <div class="row pl-3 " :key="render+'add'">
                                <label>{{ $t('AddSaleOrder.Fregiht') }}  :</label> <toggle-button v-model="purchase.isFreight" class="ml-2" color="#3178F6" style="z-index:0 !important" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-if="(purchase.paymentMethod=='Cash' || purchase.paymentMethod=='السيولة النقدية') && isRaw=='true'">
                            <div class="row pl-3 pt-2 mt-4" :key="render+'add'">

                                <label>{{ $t('AddSaleOrder.Labour') }} :</label> <toggle-button v-model="purchase.isLabour" class="ml-2" color="#3178F6" style="z-index:0 !important" />
                            </div>
                        </div>

                        <div v-if="saleDefaultVat=='DefaultVatHead' || saleDefaultVat=='DefaultVatHeadItem'" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            <label>{{ $t('AddPurchase.TaxMethod') }} :<span class="LabelColour"> *</span></label>
                            <multiselect v-if="(this.$i18n.locale == 'en' || this.isLeftToRight())" :options="['Inclusive', 'Exclusive']" v-bind:disabled="purchase.saleOrderItems.length>0" v-model="purchase.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddStockValue.SelectMethod')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            </multiselect>
                            <multiselect v-else :options="['شامل', 'غير شامل']" v-bind:disabled="purchase.saleOrderItems.length>0" v-model="purchase.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddStockValue.SelectMethod')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            </multiselect>
                        </div>
                        <div v-if="saleDefaultVat=='DefaultVatHead' || saleDefaultVat=='DefaultVatHeadItem'" class="col-xs-12 col-sm-6 col-md-6 col-lg-3" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                            <label>{{ $t('AddPurchase.VAT%') }} :<span class="LabelColour"> *</span></label>
                            <taxratedropdown v-model="purchase.taxRateId" v-bind:value="purchase.taxRateId" :isDisable="purchase.saleOrderItems.length>0? true :false" />
                        </div>

                    </div>
                    <br />

                    <saleorder-item @input="SavePurchaseItems" ref="childComponentRef" :key="rander" :wareHouseId="purchase.wareHouseId" :taxMethod="purchase.taxMethod" :taxRateId="purchase.taxRateId" />
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label>{{ $t('AddSaleOrder.TermandCondition') }}:</label>
                            <textarea class="form-control " rows="3" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'"
                                      v-model="purchase.note" />
                        </div>
                    </div>
                    <div class="row" v-if="purchase.id != '00000000-0000-0000-0000-000000000000' && purchase.approvalStatus==3">
                        <div class="col-lg-12">
                            <div class="accordion" role="tablist">
                                <b-card no-body class="mb-1">
                                    <b-card-header header-tag="header" class="p-1" role="tab">
                                        <b-button block v-b-toggle.accordion-3 variant="primary">Payment</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                            <purchaseorder-payment :totalAmount="totalAmount" :customerAccountId="customerAccountId" :show="payment" v-if="payment" @close="paymentSave" :isSaleOrder="'true'" :isPurchase="'false'" :purchaseOrderId="purchase.id" :formName="'BankReceipt'" />
                                            <div>
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="payment=true"> Add Payment</a>
                                                    </div>
                                                </div>
                                                <div class=" table-responsive">
                                                    <table class="table ">
                                                        <thead class="m-0">
                                                            <tr>
                                                                <th>#</th>
                                                                <th style="width:20%;">{{ $t('AddSaleOrder.Date') }} </th>
                                                                <th class="text-right">{{ $t('AddSaleOrder.Amount') }} </th>
                                                                <th class="text-center">{{ $t('AddSaleOrder.PaymentMode') }} </th>
                                                                <th>{{ $t('AddSaleOrder.Description') }} </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(payment,index) in purchase.paymentVoucher" v-bind:key="index">
                                                                <td>
                                                                    {{index+1}}
                                                                </td>
                                                                <th>{{getDate(payment.date)}}</th>
                                                                <th class="text-right">{{currency}} {{parseFloat(payment.amount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}</th>
                                                                <th class="text-center"><span v-if="payment.paymentMode==0">Cash</span><span v-if="payment.paymentMode==1">Bank</span></th>
                                                                <th>{{payment.narration}}</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div v-if="!loading" class="col-md-12 text-right" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            <div v-if="purchase.id === '00000000-0000-0000-0000-000000000000'">
                                <button class="btn btn-primary mr-2 float-left" v-on:click="Attachment()">
                                    {{ $t('AddSaleOrder.Attachment') }}
                                </button>

                                <button class="btn btn-primary  mr-2"
                                        v-on:click="savePurchase('Draft')"
                                        v-if="isValid('CanDraftSaleOrder')"
                                        v-bind:disabled="$v.$invalid || purchase.saleOrderItems.filter(x => x.quantity=='').length > 0">
                                    <i class="far fa-save"></i>  {{ $t('AddSaleOrder.SaveAsDraft') }}
                                </button>
                                <button class="btn btn-primary  mr-2"
                                        v-on:click="savePurchase('Approved')"
                                        v-if="isValid('CanAddSaleOrder')"
                                        v-bind:disabled="$v.$invalid || purchase.saleOrderItems.filter(x => x.quantity=='').length > 0 || purchase.saleOrderItems.filter(x => x.unitPrice=='').length > 0 || purchase.saleOrderItems.filter(x => x.outOfStock).length > 0">
                                    <i class="far fa-save"></i>  {{ $t('AddSaleOrder.SaveAsPost') }}
                                </button>
                                <button class="btn btn-primary  mr-2"
                                        v-on:click="savePurchase('Approved',true)"
                                        v-if="isValid('CanAddSaleOrder') && isValid('CanPrintSaleOrder') "
                                        v-bind:disabled="$v.$invalid || purchase.saleOrderItems.filter(x => x.quantity=='').length > 0 || purchase.saleOrderItems.filter(x => x.unitPrice=='').length > 0  || purchase.saleOrderItems.filter(x => x.outOfStock).length > 0">
                                    <i class="far fa-save"></i>  {{ $t('AddSaleOrder.SaveasPostandPrint') }}
                                </button>
                                <button class="btn btn-danger  mr-2"
                                        v-on:click="goToPurchase">
                                    {{ $t('AddSaleOrder.Cancel') }}
                                </button>
                            </div>
                            <div v-else>
                                <button class="btn btn-primary mr-2 float-left" v-on:click="Attachment()">
                                    {{ $t('AddSaleOrder.Attachment') }}
                                </button>

                                <button class="btn btn-primary  mr-2"
                                        v-on:click="savePurchase('Draft')"
                                        v-if="isValid('CanDraftSaleOrder') && isValid('CanEditSaleOrder')"
                                        v-bind:disabled="$v.$invalid || purchase.saleOrderItems.filter(x => x.quantity=='').length > 0 || purchase.saleOrderItems.filter(x => x.unitPrice=='').length > 0">
                                    <i class="far fa-save"></i>  {{ $t('AddSaleOrder.UpdateAsDraft') }}
                                </button>

                                <button class="btn btn-primary  mr-2"
                                        v-on:click="savePurchase('Approved')"
                                        v-if="isValid('CanAddSaleOrder') && isValid('CanEditSaleOrder')"
                                        v-bind:disabled="$v.$invalid || purchase.saleOrderItems.filter(x => x.quantity=='').length > 0 || purchase.saleOrderItems.filter(x => x.unitPrice=='').length > 0 || purchase.saleOrderItems.filter(x => x.outOfStock).length > 0">
                                    <i class="far fa-save"></i> {{ $t('AddSaleOrder.UpdateAsPost') }}
                                </button>
                                <button class="btn btn-primary  mr-2"
                                        v-on:click="savePurchase('Approved',true)"
                                        v-if="isValid('CanAddSaleOrder') && isValid('CanEditSaleOrder') && isValid('CanPrintSaleOrder')"
                                        v-bind:disabled="$v.$invalid || purchase.saleOrderItems.filter(x => x.quantity=='').length > 0 || purchase.saleOrderItems.filter(x => x.unitPrice=='').length > 0 || purchase.saleOrderItems.filter(x => x.outOfStock).length > 0">
                                    <i class="far fa-save"></i> {{ $t('AddSaleOrder.UpdateAsPostandPrint') }}
                                </button>
                                <button class="btn btn-danger  mr-2"
                                        v-on:click="goToPurchase">
                                    {{ $t('AddSaleOrder.Cancel') }}
                                </button>
                            </div>
                        </div>
                        <div class="card-footer col-md-3" v-else>
                            <loading :active.sync="loading"
                                     :can-cancel="true"
                                     :is-full-page="true"></loading>
                        </div>
                    </div>
                </div>
            </div>
            <bulk-attachment :attachmentList="purchase.attachmentList" :show="show" v-if="show" @close="attachmentSave" />
            <saleorder :printDetails="printDetails" :headerFooter="headerFooter" v-if="printDetails.length != 0" v-bind:key="printRender" :isTouchScreen="SaleOrder" />
        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { required } from "vuelidate/lib/validators";
    import Multiselect from 'vue-multiselect';


    //import VueBarcode from 'vue-barcode';
    export default {
        mixins: [clickMixin],
        components: {
            Multiselect,
            Loading
        },

        data: function () {
            return {
                customerAccountId: '',
                isRaw: '',
                SaleOrder: 'SaleOrder',
                payment: false,
                show: false,
                saleOrder: false,
                daterander: 0,
                rander: 0,
                render: 0,
                customerRender: 0,
                purchase: {
                    id: "00000000-0000-0000-0000-000000000000",
                    date: "",
                    customerAddress: "",
                    mobile: "",
                    logisticId: "",
                    barCode: "",
                    registrationNo: "",
                    quotationId: "",
                    customerId: "",
                    wareHouseId: "",
                    refrence: "",
                    days: '',
                    purchaseOrder: "",
                    paymentMethod: "",
                    sheduleDelivery: "",
                    note: '',
                    isFreight: false,
                    isLabour: false,
                    isQuotation: false,
                    isSerial: false,
                    soInventoryReserve: '',
                    saleOrderItems: [],
                    attachmentList: [],
                    path: '',
                    clientPurchaseNo: '',
                    taxMethod: '',
                    taxRateId: '',
                },
                loading: false,
                randerCustomer: 0,
                
                printDetails: [],

                printRender: 0,
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                isFifo: false,
                openBatch: 0,
                saleDefaultVat:''
                
            };
        },

        


        validations: {
            purchase: {
                date: { required },
                registrationNo: { required },
                customerId: { required },
                refrence: {},
                wareHouseId: { required },
                paymentMethod: { required },

                saleOrderItems: { required },
            },
        },

        methods: {
            

            Attachment: function () {
                this.show = true;
            },

            attachmentSave: function (attachment) {
                this.purchase.attachmentList = attachment;
                this.show = false;
            },

            getAddress: function () {
                this.purchase.customerAddress = this.$refs.CustomerDropdown.GetCustomerAddress().address;
                this.purchase.mobile = this.$refs.CustomerDropdown.GetCustomerAddress().mobile;
            },

            RanderCustomer: function () {
                this.randerCustomer++;
            },

            getDate: function (date) {
                if (date == null || date == undefined) {
                    return "";
                }
                else {
                    return moment(date).format('LLL');
                }
            },

            GetQuotationDetail: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Purchase/SaleOrderDetail?Id=' + id + '&isFifo=' + this.isFifo + '&openBatch=' + this.openBatch, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.purchase.date = moment(response.data.date).format('llll');
                            root.purchase.customerId = response.data.customerId;
                            root.purchase.refrence = response.data.refrence;
                            root.purchase.days = response.data.days;
                            root.purchase.purchaseOrder = response.data.purchaseOrder;
                            root.purchase.paymentMethod = response.data.paymentMethod;
                            root.purchase.sheduleDelivery = response.data.sheduleDelivery;
                            root.purchase.note = response.data.note;
                            root.purchase.isFreight = response.data.isFreight;
                            root.purchase.isLabour = response.data.isLabour;
                            root.purchase.path = response.data.path;
                            root.purchase.clientPurchaseNo = response.data.clientPurchaseNo;
                            root.purchase.taxMethod = response.data.taxMethod;

                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                                response.data.saleOrderItems.forEach(function (x) {

                                    x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.product.unitPerPack));
                                    x.quantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.product.unitPerPack)).toFixed(3).slice(0, -1);
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                                response.data.saleOrderItems.forEach(function (x) {

                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                                    x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }

                            root.$refs.childComponentRef.EmtypurchaseProductsList();
                            response.data.saleOrderItems.forEach(function (so) {
                                root.$refs.childComponentRef.addProduct(so.productId, so.product, so, true);
                            });
                            root.customerRender++;
                        }
                    },
                        function (error) {
                            root.loading = false;
                            console.log(error);
                        });
            },

            AutoIncrementCode: function () {
                var root = this;
                var token = "";
                if (root.$session.exists()) {
                    token = localStorage.getItem("token");
                }
                root.$https
                    .get("/Purchase/SaleOrderAutoGenerateNo", {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(function (response) {
                        if (response.data != null) {
                            root.purchase.registrationNo = response.data;
                        }
                    });
            },
            SavePurchaseItems: function (saleOrderItems) {

                this.purchase.saleOrderItems = saleOrderItems;
            },
            savePurchase: function (status, print) {
                this.purchase.approvalStatus = status
                localStorage.setItem('active', status);

                this.loading = true;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.purchase.isSerial = localStorage.getItem('IsSerial') == 'true' ? true : false;
                this.purchase.soInventoryReserve = localStorage.getItem('SoInventoryReserve');

                this.purchase.saleOrderItems.forEach(function (x) {
                    x.quantity = x.totalPiece;
                });
                this.purchase.isFifo = this.isFifo;
                this.$https
                    .post('/Purchase/SaveSaleOrderInformation', root.purchase, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        root.loading = false

                        root.info = response.data
                        if (print) {
                            root.PrintInvoice(response.data);

                        }
                        else {
                            root.$swal({
                                title: "Saved!",
                                text: "Data Saved Successfully!",
                                type: 'success',
                                icon: 'success',
                                timer: 1500,
                                timerProgressBar: true,
                            }).then(function (response) {
                                if (response != undefined) {
                                    if (root.purchase.id == "00000000-0000-0000-0000-000000000000" && !root.purchase.isDuplicate) {
                                        root.$router.go('AddSaleOrder');

                                    } else {
                                        root.$router.push({
                                            path: '/SaleOrder',
                                            query: {
                                                data: 'AddSaleOrders'
                                            }
                                        })
                                    }
                                }
                            });
                        }


                    })
                    .catch(error => {
                        console.log(error)
                        if (localStorage.getItem('IsMultiUnit') == 'true') {
                            root.purchase.saleOrderItems.forEach(function (x) {

                                x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.unitPerPack));
                                x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.unitPerPack));

                            });
                        }
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false)

            },
            GetPaymentVoucher: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('Purchase/SaleOrderPaymentList?id=' + this.purchase.id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {
                            root.purchase.paymentVoucher = response.data;
                        }
                    });
            },
            paymentSave: function () {
                this.payment = false;
                this.GetPaymentVoucher();
            },
            goToPurchase: function () {

                if (this.isValid('CanViewSaleOrder') || this.isValid('CanDraftSaleOrder')) {
                    this.$router.push({
                        path: '/SaleOrder',
                        query: {
                            data: 'AddSaleOrders'
                        }
                    })
                }
                else {
                    this.$router.go();
                }

            },
            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + 'iVBORw0KGgoAAAANSUhEUgAAATYAAACjCAMAAAA3vsLfAAAAhFBMVEX///8AcuEAZ98Ab+AAa+AAbeAAad9Tk+cAbuC+1fUFeOLS4/no8/0AZd8AaODv9v1to+vk7/z1+v7d6vqBru3F2vemxfKHsu5Zl+iYvfDU5PnM3/g9iea20PWNte5Rk+gwhOVIjuepx/NjnOl2p+wlfuS30fUAX96cvvAde+M1huWoxfIDNGHbAAAHKElEQVR4nO2d65aiOhBGJQlpVAKId6VVtJ3ROe//fgfvqSQocS3EjrV/NsEJ38qlqlKVabUQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEGQ30E6nG6ybcfrbPNkN2+6N68kDWVimzdHOYlYEFDP8yj1GWGT79q6+W7kQoZWfi/8IfwgmEzA/UVaY1/fiCX49k7V1wbC90wwMq2zt2/D1zOyDSkzinaAb/v19vgteEa2hSgV7TBVxQcscU/IlpB7qhUI9yeqvWxJ9EC1QrdR7f1uGGvZpndn6EW3Yf09bxRb2WZVVCsWOMcNEVvZtqqxZsafvKDvDWIp245XUq2Ypm77WpayaWONRYIxwTXjl2av6H1j2Mm2VgYb88bzwo8Nhz9MFU50X9L/hrCTbQVHmxhcn8QbxS7xk3o73ixWsvXgNgrdgYViBbM6u900VrLBORrt4NMf6KgSlzcFK9k2gdRWX/SV0eayi2Ul215uTLQ1/xsMxmBTV5/fACvZ5KWNGtoC2eiqlg6/BzayxbJs/o/eIAc/Vj1U/PuwkQ1spGynNxgA443X1OV3wEa2viwbNwQjFwxl0wGjja/1BlA2lw23p9c2k33xAz2smrr8DljtpLL/ZLIvgO8VuOzMW8kGZNE3yhi4V047pVaygUnI/6iPp3BHcPlAwUo24AZo9m4Ko0rC5fNSK9nAnuAxZRZmAZDN5R3BMt4G3QAykJ9NYACEjWvsdeMosg3bJZxO8Nowpsaz60Scb5X8BtFr7JteAJTN42X8PeVwdWBzKrLdcDZrL1ZCOWVwOv6hyVYKP8n2Rz0mpYyTiDPtV9webLaytfLgcdtDc6dXNnvZwvIULQm6bfarasdWtla7SjYDc3uKPiFba/dYN8eP5FvPyNYaPdCNEtfzjZ6SrTWM7u0LzHPZqzrzjGytOFfNtNtQEy4HPq48JVvh1Hci04tUrJxf1o48KVurtV4JxcgNmMjbjXzE61lWlC3SC2Rm41UUMRYU+IWvwLKp62bHjaUgMtERyRdlB/wCY1ZpPByNk8lkkizWXcfTTiHxrKB/otfrnUuvIGlB0/1EnKQ3/16P1t/DiutUf3hsPv+cZU2nu8gOYaADEWHL0QMt5uMVuTbn+XT2ml6+F+HCIwwksBUGRbmbFI6L5uAAkJHO7tPWwDiJDCEhKnKzpxQmxNScs/FHCTfVU+TPNiwxZBaVN/cY/YD6vjNxdqf8jGinAnebe8LtU4QbM/9upJsvYfN+cD8wzrY2Jfe/lpnRK5d1+LJq7gXeB+hW4XQgWsjNH3uxgetHCa1qNXtiZtXcY86vb4MqNXvByqq5WiDjHn218D1gJGJcMeLo37MM/WpVuMUbbttvE7grUpKNZnEaz8e+L/1xewk/fmmbKPUZ8/WJyxZ3/9lfjjJ62PYa004nZ+OMRvvrjNNKvhnPB9Ppzz/dxWAuD7cBzO0Gpdrj4/yNOtIylUDngPKLExqO1UMZp5MpgQx+Dh8mzOMeyKOHY8pfSfZZ31OSkVYv6H5DdOGGoD72oGitYXRHmFiZpSKstetNApKUIy2HWY1+jGFOs+ILdOHCZyqTcQRQIHrNQO13z8xmXYkZzEHV6zngyucP1OfOIJv8t8/cwNOsM6IDV0KubZXQBqS5+twZ5EnHr0fDiTGYRv/BetKl/nMgRZXuX/klrwQkzJPrSlYi2xLWXBns2QQYw86WqoWyDtF15zPLFmxCuwo/ZwsjgQ7kgWz+IHxUTzr9DNlSINs1OGSWje3AJOX/6b8HDRT/lZ/yUkDp2XX4mGWLhmBLYAb7Al544W6sUq50vBUylsjWAxd9mJwn0D5w9y4ysPVdJ5VZNk9JhiPamf0c+F4OF12N5Fgtv5j9RtkOgwcs+fqNFrCQjbubIgjDbZe9dPP3dOczkWU4GBzQ81evGlvDuIBwOOAG7frO6UvjS5ZbJj09mnVwAHIQ45hDT97kRTgDtLRoRxYizXxVBWhhUCZl1ihjzRBPcYgYpiVQPr1MrXQHzupPJRqhog2ZnILoaVvLb6h8PfmvRLl0zeP+ZtQeDkdJYLznKVGaB1GwWi5XvnZSHxl8L4eItbOTgPGIc+WE6nL/sN7cowXaH50/lx89uiH8wO0aXXUJK0E4n1mZl6WqSbBb/PurSkEpcfqU9EjqPczqAIWO28f1y9xdv+pGaFiboGpgeU/3j4anmhDnKOH+7sQTyqaYZvfTZz6jxu/ApjwjJmB6tvigtC7ykOzr8nG8wndgHnBU5KbMyPm2JKWyaP9RhR3pmGv/AZNHyb7MRVp3iL41+GTlbtijhHS3F1I5R+BzsrwnQvuLcKk9ZRFPnL5+vZT+buKJw9myECwbtB9FftL2IGPn9nS5cP9igTukvUOJZPVY2bF96HBsDUEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQmf8BckJbXFsgizoAAAAASUVORK5CYII=';

                if (path != null && path != '' && path != undefined) {
                    root.$https.get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }
                    });
                }
                
            },
            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.GetInvoicePrintSetting();
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            GetInvoicePrintSetting: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {
                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;

                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },
            PrintInvoice: function (value) {
                this.GetHeaderDetail();
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Purchase/SaleOrderDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            root.printDetails = response.data;
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {
                                root.printDetails.saleOrderItems.forEach(function (x) {
                                    x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.product.unitPerPack));
                                    x.newQuantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {
                                root.printDetails.saleOrderItems.forEach(function (x) {
                                    x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                                    x.newQuantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                                    x.unitPerPack = x.product.unitPerPack;
                                });
                            }
                            root.printRender++;
                            // root.$router.go('AddSaleOrder');
                        }
                    });
            },

            GetUserDefineFlow: function () {
                var root = this;
                if (localStorage.getItem('quotationToSaleOrder') == undefined) {
                    root.$https.get('/Company/UserDefineFlowEdit?companyId=' + localStorage.getItem('CompanyID'), { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                        .then(function (response) {
                            if (response.data != null) {
                                localStorage.setItem('quotationToSaleOrder', response.data.quotationToSaleOrder);
                                localStorage.setItem('quotationToSaleInvoice', response.data.quotationToSaleInvoice);
                                localStorage.setItem('partiallyQuotation', response.data.partiallyQuotation);
                                localStorage.setItem('partiallySaleOrder', response.data.partiallySaleOrder);

                                root.saleOrder = localStorage.getItem('quotationToSaleOrder') == 'true' ? true : false;
                            }
                            else {
                                console.log("error: something wrong from db.");
                            }
                        },
                            function (error) {
                                console.log(error);
                            });
                }
                else {
                    this.saleOrder = localStorage.getItem('quotationToSaleOrder') == 'true' ? true : false;

                }


            }

        },
        created: function () {
            this.$emit('input', this.$route.name);
            this.saleDefaultVat = localStorage.getItem('SaleDefaultVat');

            if (this.$route.query.data != undefined) {

                if (this.$route.query.data.isDuplicate) {
                    this.$route.query.data.id = '00000000-0000-0000-0000-000000000000';
                    this.purchase = this.$route.query.data;
                    this.purchase.isClose = false;
                    this.AutoIncrementCode();
                    this.purchase.date = moment().format('llll');
                }
                else {
                    this.purchase = this.$route.query.data;
                    this.purchase.date = moment(this.purchase.date).format('llll');
                }
                this.customerAccountId = this.$route.query.data.customerAccountId;

                if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') == 'true') {

                    this.purchase.saleOrderItems.forEach(function (x) {

                        x.highQty = parseInt(parseFloat(x.quantity) / parseFloat(x.product.unitPerPack));
                        x.quantity = parseFloat(parseFloat(x.quantity) % parseFloat(x.product.unitPerPack));
                        x.unitPerPack = x.product.unitPerPack;
                    });
                }
                if (localStorage.getItem('IsMultiUnit') == 'true' && localStorage.getItem('decimalQuantity') != 'true') {

                    this.purchase.saleOrderItems.forEach(function (x) {

                        x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                        x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));
                        x.unitPerPack = x.product.unitPerPack;
                    });
                }
                this.attachment = true;
                this.rander++;
                this.render++;
            }
            else {
                this.purchase.wareHouseId = localStorage.getItem('WareHouseId');
                this.purchase.taxRateId = localStorage.getItem('TaxRateId');
                this.purchase.taxMethod = localStorage.getItem('taxMethod');
            }

            this.GetUserDefineFlow();
        },
        mounted: function () {


            this.isRaw = localStorage.getItem('IsProduction');
            if (this.$route.query.data == undefined) {
                this.AutoIncrementCode();

                this.purchase.date = moment().format('llll');
                this.daterander++;
            }
            this.isFifo = localStorage.getItem('fIFO') == 'true' ? true : false;
            var batch = localStorage.getItem('openBatch')
            if (batch != undefined && batch != null && batch != "") {
                this.openBatch = batch
            }
            else {
                this.openBatch = 1
            }
            this.purchase.barCode = Math.floor(Math.random() * 100000000000);
        },
    };
</script>

<style scoped>
    .poHeading {
        font-size: 32px;
        font-style: normal;
        line-height: 37px;
        font-weight: 500;
        font-size: 24px;
        line-height: 26px;
        color: #3178F6;
        text-align: center
    }

    .dateHeading {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.01em;
        color: #35353D;
    }

    .bottomBorder {
        padding-top: 24px !important;
        border-bottom: 1px solid #EFF4F7;
    }
</style>
